module.exports = __webpack_public_path__ + "img/2.54d1ccc.png";